import { LineBreakTheme } from '@/components/LineBreak/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const LineBreak = GenericSlot({ as: 'br', theme: LineBreakTheme });
